var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('v-container',{staticClass:"mc-main-container",staticStyle:{"min-height":"85vh"}},[_c('vue-extend-layouts')],1),_c('FooterContacts')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }